module.exports = __webpack_public_path__ + "img/mgh-otemachi@2x.f8772ef9.jpg";